// ─── Special Symbols data ──────────────────────────────────────────────────
// Central source of truth for the "insert special symbol" picker used across
// exam creation (Teacher Dashboard, School Admin Dashboard) and exam-taking
// (SchoolExamStarted) screens. Update this list in one place to affect all
// consumers.
export const SPECIAL_SYMBOLS = [
  // Math operators
  { symbol: '±', name: 'plus minus', category: 'Math' },
  { symbol: '∓', name: 'minus plus', category: 'Math' },
  { symbol: '×', name: 'multiply times cross', category: 'Math' },
  { symbol: '÷', name: 'divide division', category: 'Math' },
  { symbol: '√', name: 'square root radical', category: 'Math' },
  { symbol: '∛', name: 'cube root', category: 'Math' },
  { symbol: '∜', name: 'fourth root', category: 'Math' },
  { symbol: '∑', name: 'sum sigma summation', category: 'Math' },
  { symbol: '∏', name: 'product pi', category: 'Math' },
  { symbol: '∞', name: 'infinity', category: 'Math' },
  { symbol: '∫', name: 'integral', category: 'Math' },
  { symbol: '∬', name: 'double integral', category: 'Math' },
  { symbol: '∂', name: 'partial derivative', category: 'Math' },
  { symbol: '∆', name: 'delta change laplacian', category: 'Math' },
  { symbol: '∇', name: 'nabla del gradient', category: 'Math' },
  { symbol: '°', name: 'degree angle', category: 'Math' },
  { symbol: '′', name: 'prime minutes feet', category: 'Math' },
  { symbol: '″', name: 'double prime seconds inches', category: 'Math' },
  { symbol: '‰', name: 'per mille per thousand', category: 'Math' },
  { symbol: '∘', name: 'ring operator composition', category: 'Math' },
  { symbol: '·', name: 'middle dot cdot', category: 'Math' },
  // Relations
  { symbol: '≈', name: 'approximately equal', category: 'Relations' },
  { symbol: '≠', name: 'not equal', category: 'Relations' },
  { symbol: '≡', name: 'identical congruent', category: 'Relations' },
  { symbol: '≤', name: 'less than or equal', category: 'Relations' },
  { symbol: '≥', name: 'greater than or equal', category: 'Relations' },
  { symbol: '≪', name: 'much less than', category: 'Relations' },
  { symbol: '≫', name: 'much greater than', category: 'Relations' },
  { symbol: '∝', name: 'proportional to', category: 'Relations' },
  { symbol: '∼', name: 'similar tilde', category: 'Relations' },
  { symbol: '≅', name: 'approximately congruent', category: 'Relations' },
  { symbol: '<', name: 'less than', category: 'Relations' },
  { symbol: '>', name: 'greater than', category: 'Relations' },
  // Logic / Sets
  { symbol: '∈', name: 'element of in set', category: 'Logic/Sets' },
  { symbol: '∉', name: 'not element of not in set', category: 'Logic/Sets' },
  { symbol: '∩', name: 'intersection and', category: 'Logic/Sets' },
  { symbol: '∪', name: 'union or', category: 'Logic/Sets' },
  { symbol: '⊂', name: 'subset of', category: 'Logic/Sets' },
  { symbol: '⊃', name: 'superset of', category: 'Logic/Sets' },
  { symbol: '⊆', name: 'subset or equal', category: 'Logic/Sets' },
  { symbol: '⊇', name: 'superset or equal', category: 'Logic/Sets' },
  { symbol: '∀', name: 'for all universal', category: 'Logic/Sets' },
  { symbol: '∃', name: 'there exists existential', category: 'Logic/Sets' },
  { symbol: '∄', name: 'there does not exist', category: 'Logic/Sets' },
  { symbol: '¬', name: 'not negation', category: 'Logic/Sets' },
  { symbol: '∧', name: 'and logical conjunction', category: 'Logic/Sets' },
  { symbol: '∨', name: 'or logical disjunction', category: 'Logic/Sets' },
  { symbol: '⊕', name: 'xor exclusive or', category: 'Logic/Sets' },
  { symbol: '∅', name: 'empty set null', category: 'Logic/Sets' },
  // Greek lowercase
  { symbol: 'α', name: 'alpha', category: 'Greek' },
  { symbol: 'β', name: 'beta', category: 'Greek' },
  { symbol: 'γ', name: 'gamma lowercase', category: 'Greek' },
  { symbol: 'δ', name: 'delta lowercase', category: 'Greek' },
  { symbol: 'ε', name: 'epsilon', category: 'Greek' },
  { symbol: 'ζ', name: 'zeta', category: 'Greek' },
  { symbol: 'η', name: 'eta', category: 'Greek' },
  { symbol: 'θ', name: 'theta lowercase', category: 'Greek' },
  { symbol: 'ι', name: 'iota', category: 'Greek' },
  { symbol: 'κ', name: 'kappa', category: 'Greek' },
  { symbol: 'λ', name: 'lambda lowercase', category: 'Greek' },
  { symbol: 'μ', name: 'mu micro', category: 'Greek' },
  { symbol: 'ν', name: 'nu', category: 'Greek' },
  { symbol: 'ξ', name: 'xi lowercase', category: 'Greek' },
  { symbol: 'π', name: 'pi lowercase', category: 'Greek' },
  { symbol: 'ρ', name: 'rho', category: 'Greek' },
  { symbol: 'σ', name: 'sigma lowercase', category: 'Greek' },
  { symbol: 'τ', name: 'tau', category: 'Greek' },
  { symbol: 'υ', name: 'upsilon lowercase', category: 'Greek' },
  { symbol: 'φ', name: 'phi lowercase', category: 'Greek' },
  { symbol: 'χ', name: 'chi', category: 'Greek' },
  { symbol: 'ψ', name: 'psi lowercase', category: 'Greek' },
  { symbol: 'ω', name: 'omega lowercase', category: 'Greek' },
  // Greek uppercase
  { symbol: 'Γ', name: 'Gamma uppercase capital', category: 'Greek' },
  { symbol: 'Δ', name: 'Delta uppercase capital', category: 'Greek' },
  { symbol: 'Θ', name: 'Theta uppercase capital', category: 'Greek' },
  { symbol: 'Λ', name: 'Lambda uppercase capital', category: 'Greek' },
  { symbol: 'Ξ', name: 'Xi uppercase capital', category: 'Greek' },
  { symbol: 'Π', name: 'Pi uppercase capital', category: 'Greek' },
  { symbol: 'Σ', name: 'Sigma uppercase capital', category: 'Greek' },
  { symbol: 'Υ', name: 'Upsilon uppercase capital', category: 'Greek' },
  { symbol: 'Φ', name: 'Phi uppercase capital', category: 'Greek' },
  { symbol: 'Ψ', name: 'Psi uppercase capital', category: 'Greek' },
  { symbol: 'Ω', name: 'Omega uppercase capital', category: 'Greek' },
  // Superscripts
  { symbol: '⁰', name: 'superscript zero power', category: 'Super/Sub' },
  { symbol: '¹', name: 'superscript one power', category: 'Super/Sub' },
  { symbol: '²', name: 'superscript two squared power', category: 'Super/Sub' },
  { symbol: '³', name: 'superscript three cubed power', category: 'Super/Sub' },
  { symbol: '⁴', name: 'superscript four power', category: 'Super/Sub' },
  { symbol: '⁵', name: 'superscript five power', category: 'Super/Sub' },
  { symbol: '⁶', name: 'superscript six power', category: 'Super/Sub' },
  { symbol: '⁷', name: 'superscript seven power', category: 'Super/Sub' },
  { symbol: '⁸', name: 'superscript eight power', category: 'Super/Sub' },
  { symbol: '⁹', name: 'superscript nine power', category: 'Super/Sub' },
  { symbol: '⁺', name: 'superscript plus positive', category: 'Super/Sub' },
  { symbol: '⁻', name: 'superscript minus negative', category: 'Super/Sub' },
  { symbol: 'ⁿ', name: 'superscript n power', category: 'Super/Sub' },
  // Subscripts
  { symbol: '₀', name: 'subscript zero', category: 'Super/Sub' },
  { symbol: '₁', name: 'subscript one', category: 'Super/Sub' },
  { symbol: '₂', name: 'subscript two', category: 'Super/Sub' },
  { symbol: '₃', name: 'subscript three', category: 'Super/Sub' },
  { symbol: '₄', name: 'subscript four', category: 'Super/Sub' },
  { symbol: '₅', name: 'subscript five', category: 'Super/Sub' },
  { symbol: '₆', name: 'subscript six', category: 'Super/Sub' },
  { symbol: '₇', name: 'subscript seven', category: 'Super/Sub' },
  { symbol: '₈', name: 'subscript eight', category: 'Super/Sub' },
  { symbol: '₉', name: 'subscript nine', category: 'Super/Sub' },
  { symbol: '₊', name: 'subscript plus', category: 'Super/Sub' },
  { symbol: '₋', name: 'subscript minus', category: 'Super/Sub' },
  { symbol: 'ₙ', name: 'subscript n', category: 'Super/Sub' },
  // Fractions
  { symbol: '½', name: 'half one half fraction', category: 'Fractions' },
  { symbol: '⅓', name: 'one third fraction', category: 'Fractions' },
  { symbol: '⅔', name: 'two thirds fraction', category: 'Fractions' },
  { symbol: '¼', name: 'one quarter fourth fraction', category: 'Fractions' },
  { symbol: '¾', name: 'three quarters three fourths fraction', category: 'Fractions' },
  { symbol: '⅕', name: 'one fifth fraction', category: 'Fractions' },
  { symbol: '⅖', name: 'two fifths fraction', category: 'Fractions' },
  { symbol: '⅗', name: 'three fifths fraction', category: 'Fractions' },
  { symbol: '⅘', name: 'four fifths fraction', category: 'Fractions' },
  { symbol: '⅙', name: 'one sixth fraction', category: 'Fractions' },
  { symbol: '⅚', name: 'five sixths fraction', category: 'Fractions' },
  { symbol: '⅛', name: 'one eighth fraction', category: 'Fractions' },
  { symbol: '⅜', name: 'three eighths fraction', category: 'Fractions' },
  { symbol: '⅝', name: 'five eighths fraction', category: 'Fractions' },
  { symbol: '⅞', name: 'seven eighths fraction', category: 'Fractions' },
  // Geometry
  { symbol: '∠', name: 'angle', category: 'Geometry' },
  { symbol: '∟', name: 'right angle', category: 'Geometry' },
  { symbol: '⊥', name: 'perpendicular', category: 'Geometry' },
  { symbol: '∥', name: 'parallel', category: 'Geometry' },
  { symbol: '△', name: 'triangle', category: 'Geometry' },
  { symbol: '▲', name: 'triangle filled', category: 'Geometry' },
  { symbol: '○', name: 'circle', category: 'Geometry' },
  { symbol: '●', name: 'circle filled', category: 'Geometry' },
  { symbol: '□', name: 'square rectangle', category: 'Geometry' },
  { symbol: '■', name: 'square filled', category: 'Geometry' },
  { symbol: '◇', name: 'diamond rhombus', category: 'Geometry' },
  { symbol: '∴', name: 'therefore', category: 'Geometry' },
  { symbol: '∵', name: 'because since', category: 'Geometry' },
  // Arrows
  { symbol: '→', name: 'right arrow forward', category: 'Arrows' },
  { symbol: '←', name: 'left arrow back', category: 'Arrows' },
  { symbol: '↑', name: 'up arrow', category: 'Arrows' },
  { symbol: '↓', name: 'down arrow', category: 'Arrows' },
  { symbol: '↔', name: 'left right arrow double horizontal', category: 'Arrows' },
  { symbol: '↕', name: 'up down arrow vertical', category: 'Arrows' },
  { symbol: '⇒', name: 'double right implies', category: 'Arrows' },
  { symbol: '⇐', name: 'double left', category: 'Arrows' },
  { symbol: '⇔', name: 'double left right if and only if iff', category: 'Arrows' },
  { symbol: '↦', name: 'maps to', category: 'Arrows' },
  { symbol: '⇌', name: 'reversible reaction equilibrium', category: 'Arrows' },
  // Currency
  { symbol: '€', name: 'euro', category: 'Currency' },
  { symbol: '£', name: 'pound sterling british', category: 'Currency' },
  { symbol: '¥', name: 'yen yuan japanese chinese', category: 'Currency' },
  { symbol: '¢', name: 'cent', category: 'Currency' },
  { symbol: '₦', name: 'naira nigeria', category: 'Currency' },
  { symbol: '₹', name: 'rupee india', category: 'Currency' },
  // Other
  { symbol: '©', name: 'copyright', category: 'Other' },
  { symbol: '®', name: 'registered trademark', category: 'Other' },
  { symbol: '™', name: 'trademark', category: 'Other' },
  { symbol: '…', name: 'ellipsis dots', category: 'Other' },
  { symbol: '•', name: 'bullet point', category: 'Other' },
  { symbol: '‖', name: 'norm double vertical bar', category: 'Other' },
  { symbol: '§', name: 'section paragraph', category: 'Other' },
  { symbol: '†', name: 'dagger', category: 'Other' },
  { symbol: '‡', name: 'double dagger', category: 'Other' },
];
